(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamosure-contact-page"] && !Shopify.designMode) return;
  try {
    
function msSetTopic(el) {
  document.querySelectorAll('.ms-topic-btn').forEach(function(b) { b.classList.remove('ms-topic-btn--active'); });
  el.classList.add('ms-topic-btn--active');
  var inp = document.getElementById('ms-topic-input');
  if (inp) inp.value = el.dataset.topic;
}
(function() {
  var ta = document.getElementById('MamosureContactForm-body');
  var cnt = document.getElementById('ms-char-cnt');
  if (ta && cnt) { ta.addEventListener('input', function() { cnt.textContent = ta.value.length; }); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mamosure-media-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  var cards=Array.from(document.querySelectorAll('#mg-grid .mg-card'));
  var lbData=cards.map(function(c){return{src:c.dataset.src||'',alt:c.dataset.alt||'',title:c.dataset.title||'',desc:c.dataset.desc||'',date:c.dataset.date||'',badge:c.dataset.badge||''}});
  var filterBtns=document.querySelectorAll('.mg-filter-btn'),noResults=document.getElementById('mg-no-results');
  filterBtns.forEach(function(btn){btn.addEventListener('click',function(){
    var f=btn.dataset.filter;
    filterBtns.forEach(function(b){b.classList.remove('mg-filter-btn--active');b.setAttribute('aria-pressed','false');});
    btn.classList.add('mg-filter-btn--active');btn.setAttribute('aria-pressed','true');
    var vis=0;
    cards.forEach(function(c){var show=(f==='all'||c.dataset.category===f);if(show){c.removeAttribute('hidden');vis++;}else{c.setAttribute('hidden','');}});
    if(noResults)noResults.hidden=vis>0;
  });});
  var lb=document.getElementById('mg-lb'),lbBd=document.getElementById('mg-lb-bd'),lbClose=document.getElementById('mg-lb-close'),lbPrev=document.getElementById('mg-lb-prev'),lbNext=document.getElementById('mg-lb-next'),lbImg=document.getElementById('mg-lb-img'),lbBadge=document.getElementById('mg-lb-badge'),lbTitle=document.getElementById('mg-lb-title'),lbDesc=document.getElementById('mg-lb-desc'),lbDate=document.getElementById('mg-lb-date'),lbCur=document.getElementById('mg-lb-cur'),lbTot=document.getElementById('mg-lb-tot'),curIdx=0,prevFocus=null;
  function openLb(idx){if(!lb)return;prevFocus=document.activeElement;curIdx=idx;show(curIdx);lb.removeAttribute('hidden');document.body.style.overflow='hidden';if(lbClose)lbClose.focus();}
  function closeLb(){if(!lb)return;lb.setAttribute('hidden','');document.body.style.overflow='';if(prevFocus)prevFocus.focus();}
  function show(idx){var d=lbData[idx];if(!d)return;if(lbImg){lbImg.src=d.src;lbImg.alt=d.alt;}if(lbBadge)lbBadge.textContent=d.badge;if(lbTitle)lbTitle.textContent=d.title;if(lbDesc)lbDesc.textContent=d.desc;if(lbDate)lbDate.textContent=d.date;if(lbCur)lbCur.textContent=idx+1;if(lbTot)lbTot.textContent=lbData.length;if(lbBadge)lbBadge.hidden=!d.badge;if(lbDesc)lbDesc.hidden=!d.desc;if(lbDate)lbDate.hidden=!d.date;}
  function prev(){curIdx=(curIdx-1+lbData.length)%lbData.length;show(curIdx);}
  function next(){curIdx=(curIdx+1)%lbData.length;show(curIdx);}
  cards.forEach(function(card){var btn=card.querySelector('[data-open-lightbox]');if(btn)btn.addEventListener('click',function(){openLb(parseInt(card.dataset.index,10));});});
  if(lbClose)lbClose.addEventListener('click',closeLb);
  if(lbBd)lbBd.addEventListener('click',closeLb);
  if(lbPrev)lbPrev.addEventListener('click',prev);
  if(lbNext)lbNext.addEventListener('click',next);
  document.addEventListener('keydown',function(e){if(!lb||lb.hidden)return;if(e.key==='Escape')closeLb();if(e.key==='ArrowLeft')prev();if(e.key==='ArrowRight')next();});
  var tx=0;if(lb){lb.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});lb.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-tx;if(Math.abs(dx)>50){dx<0?next():prev();}},{passive:true});}
})();

  } catch(e) { console.error(e); }
})();
})();
